const images = [
    { path: '/img/1.jpg', alt: 'Image 1' },
    { path: '/img/2.jpg', alt: 'Image 2' },
    { path: '/img/3.jpg', alt: 'Image 3' },
    { path: '/img/4.jpg', alt: 'Image 4' },
    { path: '/img/5.jpg', alt: 'Image 5' },
];
  
  export default images;